// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Mission_wrapper__2Yvi_","content":"Mission_content__3hS1K","title":"Mission_title__xNBhK","text":"Mission_text__2VhEl","image":"Mission_image__fxS1S"};